import cn from "classnames"
import React from "react"
import SignSVGInline from "@/common/components/sign_svg_inline"

interface SignPreviewProps {
  className?: string
  svg?: string | null
  svgB?: string | null
}

const SignPreview: React.FC<SignPreviewProps> = ({ className, svg, svgB }) => {
  const signClass = cn(
    "sign [&_*]:filter-none [&_.cutline]:hidden [&_.pdfoutline]:hidden [&_svg]:h-full [&_svg]:max-h-full [&_svg]:w-full [&_svg]:max-w-full [&_svg]:overflow-visible",
    className
  )

  return (
    <>
      {svg && <SignSVGInline component="div" svg={svg} className={signClass} />}
      {svgB && <SignSVGInline component="div" svg={svgB} className={signClass} />}
    </>
  )
}

export default SignPreview
